<div
  class="topDiv"
  [style.background-color]="backgroundColorScreen"
  style="padding: 5px"
>
  <div class="agGridOuterDiv">
    <!-- <div class="row topRowMargins headerStyle">
        <div class="dataset col-lg-12" style="margin-top: 1%">
          Value Mapping
        </div>
      </div> -->
      <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0;
          margin-top: 3%;
          ">
          <label i18n="@@spmsUserReg" class="textColour">Value Mapping</label>
          <span class="example-spacer"></span>
            <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="getRouterLink(link)"
              [queryParams]="getQueryParams(link.label)"
              [active]="link.label === 'Value Mapping'"
              style="min-width:130px; opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
        </div>
      <div style="margin-top: 25px">
        <form novalidate [formGroup]="validations_form">
          <div class="row">
            <div class="col-lg-4">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCFormulaexpression"
                >Select Library</mat-label
              >
              <mat-select
                matNativeControl
                (selectionChange)="onMappingTypeSelectionChange()"
                [(ngModel)]="selectedMappingType"
                formControlName="mappingType"
                ngDefaultControl
                required
              >
               <mat-option
                  value="AddLibrary"
                >
                Add Library
                </mat-option>
                <span  *ngFor="let data of mappingTypeData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.mappingTypeId"
                >
                {{ data.mappingTypeName }}
                </mat-option>
                </span>
               
              </mat-select> 
              <mat-error *ngFor="let validation of validation_messages.mappingType">
                <span
                    *ngIf="validations_form.get('mappingType').hasError(validation.type) &&
                    (validations_form.get('mappingType').dirty || validations_form.get('mappingType').touched)">
                    {{ validation.message }}
                </span>
            </mat-error> 
            </mat-form-field>
             </div>
            </div>
            </form>

           
                <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;margin-top: 0;">
    
                        <label i18n="@@spmsUserReg" class="textColour">Value Mapping</label>
                        
                        <span class="example-spacer"></span>
                        <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                        </button> -->
                        <button *ngIf="selectedValueMappingIndexs.length > 0" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" [style.min-width.px]="50" style="padding: 0px;" title="Delete Selected Records" (click) = "deleteSelectedList()" id="114" >Delete
                        </button>
                          <!-- Hidden file input for CSV upload -->
                          <input type="file" #fileInput  style="display: none;" (change)="onFileChange($event)">
                          <!-- Upload File Button -->
                          <button *ngIf="selectedMappingType" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                            [style.background-color]="buttonColor"
                                            title="Upload File" id="108"
                                            (click)="fileInput.click()">
                                      Upload File
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
                          </button>
                        <button *ngIf="selectedMappingType" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Create Headers" (click) = "createHeaders()" id="114" style="    padding: 0.3rem 0.5rem;
                        font-size: 0.85rem; 
                        width: auto;" id="110">Create Headers<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Create Headers"></em>
                        </button>
                         <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Create Record" (click) = "createRecord()" id="114" style="    padding: 0.3rem 0.5rem;
                         font-size: 0.85rem;
                         width: auto;" *ngIf="selectedMappingType && columnDefinitions.length > 0" id="114">Create Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Create Record"></em>
                        </button>
<!-- ========================================================== -->

<button *ngIf="selectedValueMappingIndexs.length <= 0" class="popup gridColour btn btn-rounded-button z-depth-1
        waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" [style.min-width.px]="100"
  style="font-size: 12px; padding: 4px 10px; height: 32px;" id="102" title="Import Data" id="102" (click)="importData()">
  Import
  <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
</button>
<!-- Import Button -->
<button *ngIf="selectedValueMappingIndexs.length <= 0" class="popup gridColour btn btn-rounded-button z-depth-1
                               waves-effect waves-light text-capitalize" [style.background-color]="buttonColor"
  [style.min-width.px]="100" style="font-size: 12px; padding: 4px 10px; height: 32px;" id="103" title="Export Data"
  (click)="exportData()">
  Export
  <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
</button>

<!-- ================================================ -->


                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                    <!-- <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div> -->
    
                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>
    
                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentpage}}/{{totalpages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                  </mat-toolbar>
                
                <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin" style="height: 55vh;"
                [columnDefs]="columnDefs"  [animateRows]="true"
                [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
                [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onPaginationChanged()" [components]="components"
                (gridReady)="onGridReady($event)" [hidden]="!true">
            </ag-grid-angular>
            <div class="col-lg">
              <div class="container" style="text-align: center;">
                <!-- <div class="row topRowMargins"> -->
                  <span class="example-spacer"></span>
                  <div  style=" display: inline-flex; width: 40%; height:fit-content; margin-top: 1rem;" >
                    <button i18n="@@TMRunButton" type="button"
                      [style.background-color]="buttonColor"
                      class="actionButton btn btn-rounded-button z-depth-1
                      waves-effect waves-light text-capitalize" style="padding:
                      .3rem 1.6rem;font-size: .85rem;width:100%;" id="101"  (click)="createMapping()">{{buttonName}}</button>
                    <button i18n="@@TMRunButton" type="button"
                      [style.border-color]="buttonColor"
                      class="cancelButton btn btn-rounded-button z-depth-1
                      waves-effect waves-light text-capitalize" style="padding:
                      .3rem 1.6rem;font-size: .85rem;width:100%;" (click)="cancel()">Cancel</button>
                  </div>
                  <span class="example-spacer"></span>
                <!-- </div> -->
              </div>
            </div>
        </div>
    </div>
</div>
